import {View} from '@ab/components';
import template from '../templates/list';

class List extends View {
    template = template;

    static displayName = 'Statements.Views.List';
}

export default List;
